import Vue from 'vue';
import axios from 'axios';
import {hasPermission} from "../../utils/permissions";

// initial state
const state = {
  term: {},
  terms: [],
  contract: {},
  contracts: [],
  totalPages: 0
}

// getters
const getters = {
  term: (state) => {
    return state.term;
  },
  terms: (state) => {
    return state.terms;
  },
  contract: (state) => {
    return state.contract;
  },
  contracts: (state) => {
    return state.contracts;
  },
  totalPages: (state) => {
    return state.totalPages;
  }
}

// mutations
const mutations = {
  SET_TERM(state, term) {
    state.term = term;
  },

  SET_TERMS(state, terms) {
    state.terms = terms;
  },
  SET_CONTRACT(state, contract) {
    state.contract = contract;
  },

  SET_CONTRACTS(state, contracts) {
    state.contracts = contracts;
  },


  SET_ACTION(state, action) {
    state.action = action;
  },

  SET_TOTAL_PAGES(state, totalPages) {
    state.totalPages = totalPages;
  },

  ADD_TERM(state, term) {
    state.terms.push(JSON.parse(JSON.stringify(term)));
  },

  UPDATE_Term(state, term) {
    let termIndex = state.terms.findIndex((item) => {
      return item.id === item.id;
    });
    Vue.set(state.terms, termIndex, JSON.parse(JSON.stringify(term)));
  },

  DELETE_TERM(state, term) {
    let termIndex = state.terms.findIndex((item) => {
      return item.id === term.id;
    });

    if (termIndex > -1) {
      state.terms.splice(termIndex, 1);
    }
  }
}

// actions
const actions = {

  getAllTerms({commit}, page = 1) {
    if(hasPermission('term_condition_list')) {
      const permission = {
        headers: {
          'X-Permission': 'term_condition_list'
        }
      };

      axios.get('/admin/termsandconditions?page=' + page,permission)
          .then((response) => {
            let res = response.data;
            commit('SET_TERMS', res.data);

            let totalPages = Math.ceil(res.total / res.per_page);
            commit('SET_TOTAL_PAGES', totalPages);
          });
    }
  },

  // =========================================================================

  getTerm({commit}, term) {
    if(hasPermission('term_condition_list')){
      const permission = {
        headers: {
          'X-Permission': 'term_condition_list'
        }
      };
      return axios.get('/admin/termsandconditions/show/' + term,permission)
          .then((response) => {
            commit('SET_TERM', response.data.term);
          });
    }
  },
  async deleteContract({commit},  id) {
   return await  axios.post('/admin/delete_contract/' + id)
    .then((response) => {
      return response;
    });
  },

  // =========================================================================

  createTerm({}, term) {
    let formData = new FormData();
    formData.append('value', term.body);
    if(hasPermission('term_condition_create')){
      const permission = {
        headers: {
          'X-Permission': 'term_condition_create'
        }
      };
      return axios.post('/admin/termsandconditions/store', formData, permission,{
      })
          .then((response) => {
            return response;
          })
    }
  },

// =========================================================================
getAllContracts({commit}) {
  if(hasPermission('contract_list')){
    const permission = {
      headers: {
        'X-Permission': 'contract_list'
      }
    };
    axios.get('/admin/contract_list',permission)
        .then((response) => {
          let res = response.data;
          commit('SET_CONTRACTS', res.data);

          let totalPages = Math.ceil(res.total / res.per_page);
          commit('SET_TOTAL_PAGES', totalPages);
        });
  }
},

// =========================================================================

  async getContract({commit}, id) {
    if(hasPermission('contract_list')){
      const permission = {
        headers: {
          'X-Permission': 'contract_list'
        }
      };
      return await axios.post('/admin/contract/' + id,null,permission)
          .then((response) => {
            return response.data;
          });
    }
  },

// =========================================================================

  async createContract({commit}, [contract]) {
    if(hasPermission('contract_list')){
      const permission = {
        headers: {
          'X-Permission': 'contract_list'
        }
      };
      return await axios.post('/admin/create_contract', {title:contract.title,due_date:contract.due_date,status:contract.status.value,content:contract.body},permission)
          .then((response) => {
            return response.data;
          })
    }
  },
  async updateContract({commit}, [contract]) {
    if(hasPermission('contract_list')){
      const permission = {
        headers: {
          'X-Permission': 'contract_list'
        }
      };
      return await axios.post('/admin/update_contract/'+contract.id, {id:contract.id,title:contract.title,due_date:contract.due_date,status:contract.status.value,content:contract.body},permission)
          .then((response) => {
            return response.data;
          })
    }
  },


}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
